export default {
  // 加法精确小数点
  accAdd(arg1, arg2) {
    var r1, r2, m
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return ((arg1 * m + arg2 * m) / m).toFixed(2)
  },
  formatDate(d) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
  },
  formattedDateTime(d) {
    return d.getFullYear() + '-' + (String(d.getMonth() + 1).padStart(2, '0')) + '-' +
      (String(d.getDate()).padStart(2, '0')) + ' ' +
      (String(d.getHours()).padStart(2, '0')) + ':' +
      (String(d.getMinutes()).padStart(2, '0')) + ':' +
      (String(d.getSeconds()).padStart(2, '0'))
  },

  contactRelation: [{
    value: '本人',
    label: '本人'
  }, {
    value: '配偶',
    label: '配偶'
  }, {
    value: '父母',
    label: '父母'
  }, {
    value: '亲属',
    label: '亲属'
  }, {
    value: '子女',
    label: '子女'
  }, {
    value: '朋友',
    label: '朋友'
  }, {
    value: '工作证明人',
    label: '工作证明人'
  }, {
    value: '同事',
    label: '同事'
  }, {
    value: '兄弟姐妹',
    label: '兄弟姐妹'
  }, {
    value: '其它联系人',
    label: '其它联系人'
  }, {
    value: '通讯录',
    label: '通讯录'
  }, {
    value: '通话详单',
    label: '通话详单'
  }],
  callStatus: [{
    value: 'CS10',
    label: '电话接通'
  }, {
    value: 'CS20',
    label: '无人接通'
  }, {
    value: 'CS30',
    label: '空号'
  }, {
    value: 'CS40',
    label: '停机'
  }, {
    value: 'CS50',
    label: '拒接'
  }, {
    value: 'CS60',
    label: '挂断'
  }, {
    value: 'CS70',
    label: '拉黑'
  }, {
    value: 'CS80',
    label: '关机'
  }],
  callResult: [{
    value: 'CR10',
    label: '承诺当天还款'
  }, {
    value: 'CR11',
    label: '承诺其他天还款'
  }, {
    value: 'CR20',
    label: '第三方代偿'
  }, {
    value: 'CR30',
    label: '转告'
  }, {
    value: 'CR40',
    label: '停催'
  }, {
    value: 'CR50',
    label: '电催跟进'
  }, {
    value: 'CR60',
    label: '失联'
  }, {
    value: 'CR70',
    label: '拒绝还款'
  }, {
    value: 'CR80',
    label: '重点跟进'
  }, {
    value: 'CH10',
    label: '半失联'
  }, {
    value: 'CH20',
    label: '可联/有意愿无能力'
  }, {
    value: 'CH30',
    label: '可联/无意愿无能力'
  }, {
    value: 'CH40',
    label: '可联/恶意欺诈'
  }],
  // 表头对应数据
  tableProp: {
    'contactsInfo': [
    // {
    //   prop: 'remindeContent',
    //   label: '催记内容'
    // }, 
    {
      prop: 'typeName',
      label: '联系方式'
    }, {
      // prop: 'contactRelation',
      prop: 'relationName',
      label: '关系'
    }, {
      prop: 'contactName',
      label: '姓名'
    }, {
      prop: 'contactPhone',
      label: '联系号码'
    }, {
      // prop: 'createdAt',
      prop: 'latestContactTime',
      label: '最近联系时间'
    }, {
      // prop: 'remarks',
      prop: 'contactResult',
      label: '联系结果'
    }],
    'userContactsInfo': [{
      prop: 'phone',
      label: '号码'
    }, {
      prop: 'name',
      label: '姓名'
    }, {
      prop: 'totalCount',
      label: '通话次数'
    }, {
      prop: 'sumDuration',
      label: '通话总时长'
    }],
    'userCallsInfo': [{
      prop: 'phone',
      label: '号码'
    }, {
      prop: 'dialed',
      label: '呼入次数'
    }, {
      prop: 'dial',
      label: '呼出次数'
    }, {
      prop: 'total',
      label: '总通话次数'
    }],
    'userAddress': [{
      prop: 'name',
      label: '收货人姓名'
    }, {
      prop: 'mobile',
      label: '收货人电话'
    }, {
      prop: 'address',
      label: '收货人地址'
    }],
    'obligation': [{
      prop: 'id',
      label: '贷款编号'
    }, {
      prop: 'name',
      label: '客户姓名'
    }, {
      prop: 'phone',
      label: '号码'
    }, {
      prop: 'taskStatus',
      label: '案件状态'
    }],
    'division': [{
      prop: 'cancelCreator',
      label: '撤案操作人'
    }, {
      prop: 'name',
      label: '催收员'
    }, {
      prop: 'createDate',
      label: '分案时间'
    }, {
      prop: 'divisionAccountsAge',
      label: '分案类型'
    }, {
      prop: 'divisionAmount',
      label: '分案金额'
    }, {
      prop: 'creator',
      label: '分案操作人'
    }, {
      prop: 'workQueueName',
      label: '分案队列'
    }, {
      prop: 'cancelDate',
      label: '撤案时间'
    }, {
      prop: 'cancelType',
      label: '撤案类型'
    }],
    'phone': [{
      prop: 'phone',
      label: '电话号码'
    }, {
      prop: 'count',
      label: '次数'
    }]
  }
}
